import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/api-service/api.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HelpersService } from '../../../shared/helpers/helpers.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { PermissionHelper, ActionType } from '../../../shared/helpers/permissionshelper';
import { Logging } from '../../../logging';

@Component({
  selector: 'app-apps-edit',
  templateUrl: './apps-edit.component.html',
  styleUrls: []
})
export class AppsEditComponent implements OnInit {
  editid: any;
  inputform: any;
  showErrors :Boolean = false;
  loading: boolean;
  hasError: boolean;
  errorMessage: any;
  successMessage : any;
  editedapp: any = '';

  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService,
    private formBuilder: FormBuilder, 
    private permhelper:PermissionHelper,
    private route: ActivatedRoute, private action: ActionType) { }

    activeRoute: string = "editapp";

  ngOnInit() {

    this.inputform = new FormGroup({
      description: new FormControl('',Validators.required),
      callbackurl: new FormControl(),
      settlementcallbackurl: new FormControl()
    });

    // get URL parameters
    this.route.params.subscribe(params => {
      if(params['appid']){
        this.editid = params['appid'];
        this.fetchDetailsForEdit(this.editid);
        
      }
      else{
        this.helpers.flashWarning('Please select an app to edit');
        this.router.navigate(['/apps']);
      }
       
    });
  }


  fetchDetailsForEdit(appid: number)
  {
    this.api.get('/campaigns/accounts/'+this.auth.getAccountID()+'/apps/'+appid)
    .subscribe(
      res_data => {
        Logging.log(res_data.data);
        this.editedapp = res_data.data[0];
        this.inputform.controls.description.setValue(res_data.data[0].description);
        this.inputform.controls.callbackurl.setValue(res_data.data[0].callbackurl);
        this.inputform.controls.settlementcallbackurl.setValue(res_data.data[0].settlementcallbackurl);

      }, error_message => {
       //  this.loading = false;
       //  this.hasError = true;
      this.helpers.flashDanger('An error has occured. Please refresh page or try again later');
      }
    );
  }

  onSubmit()
  {

    //Set loading to true to show loader
    this.loading = true;
    this.hasError = false;

    if(this.inputform.valid){
      Logging.log(this.inputform.value);
      const regfields = this.inputform.value;

      const requestpayload = {
        id : this.editid,
        accountid: this.auth.getAccountID(),
        description: regfields.description,
        callbackurl : regfields.callbackurl,
        settlementcallbackurl : regfields.settlementcallbackurl
      };
      //Save details the endpoint
    
      this.api.put('/campaigns/accounts/'+this.auth.getAccountID()+'/apps/'+this.editid, requestpayload)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);
        this.helpers.flashSuccess('App details saved successfully');
        
        this.router.navigate(['/apps']);
          
        }, error_message => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
        }
      );
      

    }
    else
    {
      this.loading = false;
      this.hasError = false;

      this.showErrors = true;
      Logging.log('Has Errors', this.inputform.value);
    }
  }



  clearErrors()
  {
    this.hasError = false;
    this.errorMessage ="";
    this.loading= false;
  }

}



// WEBPACK FOOTER //
// ./src/app/client/apps/apps-edit/apps-edit.component.ts